<template>
  <v-btn
    class="_account-back-button"
    v-bind="$attrs"
    :absolute="absolute"
    :exact="exact"
    :text="text"
    v-on="$listeners">
    <v-icon left>
      mdi-chevron-left
    </v-icon>
    กลับ
  </v-btn>
</template>

<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: true
    },
    exact: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
._account-back-button {
  top: 10px;
  left: 10px;
}
</style>
